import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Modal, Spinner } from "react-bootstrap";
import { Add } from 'iconsax-react';
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter } from '../../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../../api-client/MyApiClient';
import DEFAULT_USER from "../../../../../images/DEFAULT_USER.png";
import { dateTimeSort } from '../../../../components/Util/oders';
import { formattaPrezzo } from "../../../../components/Util/prezzi";

// Valori del filtro Stato, come compaiono nella lista.
const STATO_OPTIONS = ['Attivo', 'Completato', 'Invito in corso', 'Disattivo'];

// Mappa classe stato (dal profilo) → variante badge del design system
const STATUS_BADGE = {
	'text-success': 'success',
	'text-warning': 'warning',
	'text-danger': 'danger',
	'text-primary': 'info',
	'text-muted': 'muted',
};

export const PlayerTable = () => {
	const navigate = useNavigate();

	const [loadingShowed, setLoadingShowed] = useState(false);

	const data_column = [
		{
			Header: 'Nome e cognome',
			Footer: 'Nome e cognome',
			accessor: 'name',
			Cell: ({ row }) => (
				<div style={{ display: 'flex', alignItems: 'center' }}>
				  <img
					src={row.original.imageUrl ? row.original.imageUrl : DEFAULT_USER}
					alt={row.original.name}
					style={{
					  width: '28px',
					  height: '28px',
					  borderRadius: '50%',
					  marginRight: '10px',
					  objectFit: 'cover',
					  background: '#F1F2F4',
					  flexShrink: 0
					}}
				  />
				  {row.original.name}
				</div>
			)
		},
		{
			Header: 'Email',
			Footer: 'Email',
			accessor: 'email',
		},
		{
			Header: 'Telefono',
			Footer: 'Telefono',
			accessor: 'phone',
		},
		{
			Header: 'Totale speso',
			accessor: 'totale',
		},
		{
			Header: 'Data di registrazione',
			accessor: 'date',
			sortType: dateTimeSort,
		},
		{
			Header: 'Stato',
			Footer: 'Stato',
			accessor: row => row.status?.label || '',
			Cell: ({ row }) => {
				const status = row.original.status;
				if (!status) return null;
				const variant = STATUS_BADGE[status.class] || 'muted';
				return <span className={`sid-badge sid-badge--${variant}`}>{status.label}</span>;
			},
		},
	];

	const [data_json, setDataJson] = useState(null);
	// Chip a scelta multipla: all'inizio tutti accesi
	const [statusFilter, setStatusFilter] = useState(STATO_OPTIONS);

	// Filtro per stato (dropdown "Tutti gli stati"). Mantiene null durante il caricamento.
	const filteredData = data_json
		// Uno stato fuori dai chip (o mancante) resta sempre visibile
		? data_json.filter((r) => !STATO_OPTIONS.includes(r.status?.label) || statusFilter.includes(r.status?.label))
		: data_json;

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const [customersData] = await Promise.all([
                        // apiClient.getMemberships(token, 'MEMBER', null, 'CONFIRMED')
						apiClient.getCustomers(token)
                    ]);
					setLoadingShowed(false);

					let data_customers = [];
					if(customersData && customersData.items) {
						customersData.items.forEach(element => {
							
							const createdAt = element.createdAt;
							const data = new Date(createdAt);
							const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
							const formattedDate = data.toLocaleDateString('it-IT', options);

							let image = null;
							if(element.picture && element.picture.uri) {
								image = element.picture.uri;
							}

							let status = null;
                            if(element.profileStatus==='INACTIVE') {
                                status = {
                                    "label": "Disattivo",
                                    "class": "text-muted"
                                };
                            } else if(element.profileStatus==='ACTIVE') {
                                status = {
                                    "label": "Attivo",
                                    "class": "text-success"
                                };
                            } else if(element.profileStatus==='COMPLETED') {
                                status = {
                                    "label": "Completato",
                                    "class": "text-success"
                                };
                            } else if(element.profileStatus==='INVITED') {
                                status = {
                                    "label": "Invito in corso",
                                    "class": "text-warning"
                                };
                            }
							
							let customers_row = {
								"id": element.customerUserId,
								"date": formattedDate,
								"name": element.name,
								"totale": formattaPrezzo(element.totalSpent || 0),
								"email": element.email,
								"phone": element.phoneNumber || '',
								"imageUrl": image,
								"status": status || { "label": ({ SUSPENDED: "Sospeso", INVITED: "Invitato" })[element.profileStatus || element.status] || element.profileStatus || element.status || "—", "class": "" }, // stato non previsto: si mostra invece di bloccare la lista
							};
							
							data_customers.push(customers_row);
						});
					}
					setDataJson(data_customers);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

    }, []);

	function openDetail(row) {
		navigate('/struttura/clienti/player_profile/'+row.id);
	}

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<TabellaLista
				pageList={true}
				openColumn={'name'}
				openRow={(row) => openDetail(row)}
				cardTitle={'Player'}
				searchPlaceholder={'Cerca per nome, cognome o email'}
				hasSearch={true}
				hasFilter={false}
				headerButtons={
					<>
						<Link to="/struttura/clienti/invita" className="btn sid-btn-ghost">Invita</Link>
						<Link to="/struttura/clienti/importa" className="btn sid-btn-ghost">Importa</Link>
						<Link to="/struttura/clienti/nuovo" className="btn btn-primary"><Add size={16} className="me-1" />Aggiungi Player</Link>
					</>
				}
				filterControl={
					<div className="sid-chip-filters">
						<ChipFilter label="Stato" options={STATO_OPTIONS} value={statusFilter} onChange={setStatusFilter} multiple />
					</div>
				}
				data_column={data_column}
				data_json={filteredData}
				sort_by={'date'}
                sort_type={'desc'}
			/>
		</>
	)

}
export default PlayerTable;